<template>
  <v-card
    :id="
      ($store.state.auth.user.roles[0] == $store.state.constants.roles.SECURITY
        ? 'security'
        : 'admin') + '-contractor-profile'
    "
    height="100%"
    tile
    v-cloak
    v-if="contractorCompany && isReady"
    style="overflow-y: auto;"
  >
    <!-- edit modal -->
    <v-dialog v-model="comment.show" max-width="800px">
      <v-card>
        <v-app-bar flat>
          <v-toolbar-title>{{ comment.title }}</v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          <p>{{ comment.value }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="comment.show = false">
            {{ resx.labels.close }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- edit modal -->

    <v-card-title>
      <v-row>
        <v-col cols="1" class="back" @click.prevent="goBack">
          <v-icon>
            chevron_left
          </v-icon>
        </v-col>
        <v-col cols="2" sm="1" class="contractor-profile-logo" style="flex-shrink:0">
          <v-row>
            <v-avatar
              :size="$vuetify.breakpoint.smAndDown ? 48 : 75"
              color="primary"
            >
              <span
                class="display-1 white--text"
                :class="{ subheading: $vuetify.breakpoint.smAndDown }"
              >
                {{ initials }}
              </span>
            </v-avatar>
          </v-row>
          <v-row v-if="contractorCompany.contractor.avgRate">
            <v-icon
              color="success"
              :size="16"
              class="d-inline-block star-rating"
            >
              star_rate
            </v-icon>
            <span class="caption">
              ({{ contractorCompany.contractor.avgRate }})
            </span>
          </v-row>
        </v-col>
        <v-col cols="9" sm="6">
          <v-row>
            <span
              class="display-1"
              :class="{ title: $vuetify.breakpoint.smAndDown }"
            >
              {{ contractorCompany.contractor.name }}
            </span>
          </v-row>
          <v-row>
            <span
              class="headline grey--text"
              :class="{ subheading: $vuetify.breakpoint.smAndDown }"
              >{{
                `${contractorCompany.contractor.identifier.type.toUpperCase()} ${
                  contractorCompany.contractor.identifier.number
                }`
              }}</span
            >
          </v-row>
          <v-row>
            <span
              class="headline grey--text"
              :class="{ subheading: $vuetify.breakpoint.smAndDown }"
              >{{ contractorCompany.type.name }}</span
            >
          </v-row>
          <v-row>
            <span
              v-if="$store.state.auth.user.company.isBuiltIn"
              class="headline grey--text"
              :class="{ subheading: $vuetify.breakpoint.smAndDown }"
              >{{
                contractorCompany.contractor.company &&
                  contractorCompany.contractor.company.name
              }}</span
            >
          </v-row>
        </v-col>
        <v-col cols="12" sm="4" class="action-column">
          <v-row>
            <v-col cols="6">
              <v-row
                v-if="
                  $store.state.auth.user.roles[0] ==
                    $store.state.constants.roles.SECURITY ||
                    $store.state.auth.user.roles[0] ==
                      $store.state.constants.roles.ADMIN
                "
                class="aptitude-container justify-center"
              >
                <span
                  class="headline ml-2"
                  :class="{
                    subheading: $vuetify.breakpoint.smAndDown,
                    'success--text': isSuitable,
                    'error--text': !isSuitable
                  }"
                  >{{
                    isSuitable
                      ? resx.labels.suitable.toUpperCase()
                      : resx.labels.notSuitable.toUpperCase()
                  }}</span
                >
              </v-row>
              <v-row class="justify-center">
                <v-icon
                  :size="$vuetify.breakpoint.smAndDown ? 20 : 40"
                  color="success"
                  v-if="isSuitable"
                  >check_circle</v-icon
                >
                <v-icon
                  :size="$vuetify.breakpoint.smAndDown ? 20 : 40"
                  color="error"
                  v-if="!isSuitable"
                  >error</v-icon
                >
              </v-row>
            </v-col>
            <v-col cols="5">
              <v-btn
                :loading="requestAccessButtonLoading"
                :color="requestAccessButtonColor"
                v-if="requestAccessButtonShow && showAllowAccess"
                @click="requestAccessButtonClicked"
              >
                {{ requestAccessButtonLabel }}
              </v-btn>
              <v-alert 
                :value="requestAccessAlertValue"
                :color="requestAccessAlertColor"
                dark
                align="center"
                v-if="visit && visit.state == 'pending_authorization'"
              >
                {{ requestAccessAlertLabel }}
              </v-alert>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-tabs
        :icons-and-text="$vuetify.breakpoint.smAndUp"
        centered
        grow
        v-if="
          $store.state.auth.user.roles[0] !=
            $store.state.constants.roles.SECURITY
        "
      >
        <v-tabs-slider color="accent"></v-tabs-slider>
        <v-tab
          href="#obligations"
          v-if="
            $store.state.auth.user.roles[0] !=
              $store.state.constants.roles.SECURITY"
        >
          <span v-if="$vuetify.breakpoint.smAndUp">{{
            resx.labels.obligations
          }}</span>
          <v-icon>description</v-icon>
          <v-badge overlap color="error" v-if="countInvalidObligations > 0">
            <span slot="badge">{{
              countInvalidObligations}}
            </span>
          </v-badge>
        </v-tab>
        <v-tab href="#vehicles">
          <span v-if="$vuetify.breakpoint.smAndUp">{{
            resx.labels.vehicles
          }}</span>
          <v-icon>commute</v-icon>
          <v-badge overlap color="error" v-if="
            countInvalidVehiclesObligations > 0 &&
            $store.state.auth.user.roles[0] !=
            $store.state.constants.roles.SECURITY"
          >
            <span slot="badge">{{
              countInvalidVehiclesObligations}}
            </span>
          </v-badge>
        </v-tab>
        <v-tab href="#employees">
          <span v-if="$vuetify.breakpoint.smAndUp">{{
            resx.labels.employees
          }}</span>
            <v-icon>people</v-icon>
          <v-badge overlap color= "error" v-if="
            countInvalidEmployeesObligations > 0 &&
            $store.state.auth.user.roles[0] !=
            $store.state.constants.roles.SECURITY
          ">
            <span slot="badge">{{
              countInvalidEmployeesObligations }}
            </span>
          </v-badge>
        </v-tab>
        <v-tab
          href="#history"
          v-if="
            $store.state.auth.user.roles[0] !=
              $store.state.constants.roles.SECURITY
          "
        >
          <span v-if="$vuetify.breakpoint.smAndUp">{{
            resx.labels.historyVisits
          }}</span>
          <v-icon>history</v-icon>
        </v-tab>

        <v-tab-item
          style="overflow-y: auto;"
          value="obligations"
          v-if="
            $store.state.auth.user.roles[0] !=
              $store.state.constants.roles.SECURITY
          "
        >
          <contractor-obligations-details
            :obligations="getContractorObligations"
            @viewComment="viewComment($event)"
          ></contractor-obligations-details>
        </v-tab-item>

        <v-tab-item value="vehicles">
          <contractor-obligations-vehicles-details
            v-if="visit != null"
            :hasVisit="true"
            :visitVehicles="visit.vehicles"
            :delayedObligations="contractorCompany.delayedObligations"
            :vehicles="contractorCompany.vehicles"
            :obligations="getVehicleObligations"
            @viewComment="viewComment($event)"
            @updateVehicles="updateVehicles"
          ></contractor-obligations-vehicles-details>
          <contractor-obligations-vehicles-details
            v-else
            :hasVisit="false"
            :visitVehicles="[]"
            :delayedObligations="contractorCompany.delayedObligations"
            :vehicles="contractorCompany.vehicles"
            :obligations="getVehicleObligations"
            @viewComment="viewComment($event)"
            @updateVehicles="updateVehicles"
          ></contractor-obligations-vehicles-details>
        </v-tab-item>

        <v-tab-item value="employees">
          <contractor-employees-details
            v-if="visit != null"
            :hasVisit="true"
            :visitEmployees="visit.employees"
            :delayedObligations="contractorCompany.delayedObligations"
            :employees="contractorCompany.employees"
            :obligations="getEmployeeObligations"
            @updateEmployees="updateEmployees"
            @updatePersonalProtectionItem="updatePersonalProtectionItem"
          ></contractor-employees-details>

          <contractor-employees-details
            v-else
            :hasVisit="false"
            :visitEmployees="[]"
            :delayedObligations="contractorCompany.delayedObligations"
            :employees="contractorCompany.employees"
            :obligations="getEmployeeObligations"
            @updateEmployees="updateEmployees"
            @updatePersonalProtectionItem="updatePersonalProtectionItem"
          ></contractor-employees-details>
        </v-tab-item>

        <v-tab-item
          value="history"
          v-if="
            $store.state.auth.user.roles[0] !=
              $store.state.constants.roles.SECURITY
          "
        >
          <contractor-history-details
            :history="history"
            @viewComment="viewComment($event)"
          ></contractor-history-details>
        </v-tab-item>
      </v-tabs>
      <v-row
        v-if="
          $store.state.auth.user.roles[0] ==
            $store.state.constants.roles.SECURITY
        "
      >
        <v-col class="vehicles" cols="6" href="#vehicles">
          <div class="col v-tabs__div">
            <v-icon>commute</v-icon><br />{{ resx.labels.vehicles }}
          </div>
          <contractor-obligations-vehicles-details
            :visit="this.visit || null"
            :alreadyIn="this.alreadyInVehicles"
            :delayedObligations="contractorCompany.delayedObligations"
            :vehicles="contractorCompany.vehicles"
            :obligations="getVehicleObligations"
            @viewComment="viewComment($event)"
            @updateVehicles="updateVehicles"
          ></contractor-obligations-vehicles-details>
        </v-col>
        <v-col class="employees" cols="6" href="#employees">
          <v-row>
            <v-col Class="col col-8">
              <div class="v-tabs__div">
                <v-icon>people</v-icon><br />{{ resx.labels.employees }}
              </div>
            </v-col>
            <v-col Class="col col-4" v-if="this.personalProtectionItems.verify">
              <v-row class="personal-protection-items-images">
                <v-row class="col-12 flex-row"
                justify="end">
                    
                  <img src="/images/epp/casco.png" style="width: 30px;" />
                  <img
                    src="/images/epp/calzado-de-seguridad.png"
                    style="width: 30px;"
                  />
                  <img src="/images/epp/guantes.png" style="width: 30px;" />
                  <img src="/images/epp/gafas.png" style="width: 30px;" />
                  <img
                    src="/images/epp/protector-auditivo.png"
                    style="width: 30px;"
                  />
                </v-row>
                <v-row class="col-12 flex-row"
                  justify="end">
                  <img
                    src="/images/epp/mascara-de-gas.png"
                    style="width: 30px;"
                  />
                  <img src="/images/epp/uniforme.png" style="width: 30px;" />
                  <img
                    src="/images/epp/chaleco-reflectante.png"
                    style="width: 30px;"
                  />
                  <img
                    src="/images/epp/arnes-de-seguridad.png"
                    style="width: 30px;"
                  />
                  <img
                    src="/images/epp/mascara-para-soldar.png"
                    style="width: 30px;"
                  />
                </v-row>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <contractor-employees-details
              :alreadyIn="alreadyInEmployees"
              :delayedObligations="contractorCompany.delayedObligations"
              :employees="contractorCompany.employees"
              :obligations="getEmployeeObligations"
              :personalProtectionItems="personalProtectionItems"
              :visit="visit || null"
              @viewComment="viewComment($event)"
              @updateEmployees="updateEmployees"
              @updatePersonalProtectionItem="updatePersonalProtectionItem"
            ></contractor-employees-details>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";
import contractorCompanyService from "@/services/ContractorCompanyService";
import contractorObligationsDetails from "./contractor-obligations-details.view.vue";
import contractorObligationsVehiclesDetails from "./contractor-obligations-vehicles-details.view.vue";
import contractorEmployeesDetails from "./contractor-employees-details.view.vue";
import contractorHistoryDetails from "./contractor-history-details.view.vue";

export default {
  name: "contractorProfile",
  async mounted() {
    this.contractorCompany = await contractorCompanyService.getById(
      this.$route.params.id
    );
    this.obligations = await contractorCompanyService.getObligations(
      this.$route.params.id
    );
    this.history = await contractorCompanyService.getHistory(
      this.$route.params.id
    );
    this.goBackTimeout = null;
    this.showAllowAccess = true;
    this.alreadyInEmployees = [];
    this.alreadyInVehicles = [];

    this.personalProtectionItems = this.contractorCompany.personalProtectionItems;
    this.employeesPersonalProtectionItemsVerified = true;
    this.employeesPersonalProtectionItemsVerify = this.personalProtectionItems.verify;

    this.contractorCompany.employees.forEach(employee => {
      employee.currentPersonalProtectionItems = {
        helmet: this.personalProtectionItems.helmet ? true : false,
        securityShoes: this.personalProtectionItems.securityShoes
          ? true
          : false,
        gloves: this.personalProtectionItems.gloves ? true : false,
        goggles: this.personalProtectionItems.goggles ? true : false,
        auditoryProtector: this.personalProtectionItems.auditoryProtector
          ? true
          : false,
        gasMask: this.personalProtectionItems.gasMask ? true : false,
        uniform: this.personalProtectionItems.uniform ? true : false,
        reflectiveVest: this.personalProtectionItems.reflectiveVest
          ? true
          : false,
        safetyHarness: this.personalProtectionItems.safetyHarness
          ? true
          : false,
        weldingMask: this.personalProtectionItems.weldingMask ? true : false,
        verifies: this.personalProtectionItems.verifies ? true : false,
        selected: false
      };
    });

    this.history.forEach(visit => {
      if (visit.state == "active") {
        visit.employees.forEach(employee => {
          this.alreadyInEmployees.push(employee);
        });
        visit.vehicles.forEach(vehicle => {
          this.alreadyInVehicles.push(vehicle);
        });
      }
      if (
        (visit.state == "pending_authorization" ||
          visit.state == "authorized") &&
        visit.hasRequestAccess
      ) {
        this.visit = visit;
        this.showAllowAccess = true;
      }
    });
    this.requestAccesses = await contractorCompanyService.getRequestAccess(
      this.$route.params.id
    );
    this.isLoading = false;
  },
  components: {
    contractorObligationsDetails,
    contractorObligationsVehiclesDetails,
    contractorEmployeesDetails,
    contractorHistoryDetails
  },
  computed: {
    isReady() {
      return (
        !this.isLoading &&
        this.countInvalidObligations >= 0 &&
        this.countInvalidVehiclesObligations >= 0 &&
        this.countInvalidEmployeesObligations >= 0
      );
    },
    countInvalidObligations() {
      return this.getContractorObligations.filter(
        o =>
          o.type == this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION &&
          contractorCompanyService.isInvalidObligation(o)
      ).length;
    },
    countInvalidVehiclesObligations() {
      return this.getVehicleObligations.filter(
        o =>
          o.type ==
            this.$store.state.constants.OBLIGATIONS.TYPES.VEHICLE_OBLIGATION &&
          contractorCompanyService.isInvalidObligation(o)
      ).length;
    },
    countInvalidEmployeesObligations() {
      return this.getEmployeeObligations.filter(
        o =>
          o.type ==
            this.$store.state.constants.OBLIGATIONS.TYPES
              .EMPLOYEES_OBLIGATION &&
          contractorCompanyService.isInvalidObligation(o)
      ).length;
    },
    isSuitable() {
      return this.contractorCompany.hasDelayed == false;
    },
    getContractorObligations() {
      return this.obligations.filter(
        o =>
          o.type == this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION &&
          o.status != this.$store.state.constants.OBLIGATIONS.STATUS.EXCLUDED &&
          o.status !=
            this.$store.state.constants.OBLIGATIONS.STATUS.APPROVAL_PENDING
      );
    },
    getVehicleObligations() {
      return this.obligations.filter(
        o =>
          o.type ==
            this.$store.state.constants.OBLIGATIONS.TYPES.VEHICLE_OBLIGATION &&
          o.status != this.$store.state.constants.OBLIGATIONS.STATUS.EXCLUDED &&
          o.status !=
            this.$store.state.constants.OBLIGATIONS.STATUS.APPROVAL_PENDING
      );
    },
    getEmployeeObligations() {
      return this.obligations.filter(
        o =>
          o.type ==
            this.$store.state.constants.OBLIGATIONS.TYPES
              .EMPLOYEES_OBLIGATION &&
          o.status != this.$store.state.constants.OBLIGATIONS.STATUS.EXCLUDED &&
          o.status !=
            this.$store.state.constants.OBLIGATIONS.STATUS.APPROVAL_PENDING
      );
    },
    hasPendingRequestAccess() {
      return (
        this.requestAccesses.filter(ra => {
          let visit = contractorCompanyService.getVisitForRequestAccess(ra.id)
          return ra.approvedBy == null &&
            visit.state != this.$store.state.constants.VISIT.cancelled
        }).length > 0
      );
    },
    requestAccessWithoutVisit() {
      return this.requestAccesses.filter(
        ra => ra.approvedBy != null && ra.contractorVisit == null
      )[0];
    },
    hasRequestAccessWithVisit() {
      return (
        this.visit &&
        this.visit.state == "authorized" &&
        this.requestAccesses.filter(
          ra => ra.approvedBy != null && ra.contractorVisit != null
        ).length > 0
      );
    },
    initials() {
      const parts =
        this.contractorCompany.contractor &&
        this.contractorCompany.contractor.name.split(" ");
      let initials = "";
      parts.forEach(part => {
        initials += part[0];
      });
      return initials.substring(0, 3);
    },
    selectIsAuthorized() {
      if (this.contractorCompany.hasDelayed == false) {
        if (this.employees.length > 0 || this.vehicles.length > 0) {
          return this.vehiclesIsAuthorized && this.employeesIsAuthorized;
        }
      }
      return false;
    },
    selectIsActive() {
      return this.employees.length > 0 || this.vehicles.length > 0;
    },
    requestAccessAlertColor() {
      let color = "error";
      return color;
    },
    requestAccessAlertLabel() {
      let label = "Pendiente autorizar ingreso";
      return label;
    },
    requestAccessAlertValue() {
      let value = this.hasPendingRequestAccess;
      return value;
    },
    requestAccessButtonColor() {
      let color = "error";
      if (this.hasPendingRequestAccess) {
        color = "error";
      } else if (this.hasRequestAccessWithVisit) {
        color = "success";
      } else if (this.selectIsAuthorized) {
        color = this.employeesPersonalProtectionItemsVerified
          ? "success"
          : "warning";
      } else if (!this.selectIsAuthorized) {
        color = "warning";
      }
      return color;
    },
    requestAccessButtonLabel() {
      let label = "error";
      if (this.hasPendingRequestAccess) {
        label = "Solicitar autorización de ingreso";
      } else if (this.hasRequestAccessWithVisit) {
        label = "Registrar ingreso";
      } else if (this.selectIsAuthorized) {
        label = this.employeesPersonalProtectionItemsVerified
          ? "Permitir ingreso"
          : "Solicitar autorización de ingreso";
      } else if (!this.selectIsAuthorized) {
        label = "Solicitar autorización de ingreso";
      }
      return label;
    },
    requestAccessButtonLoading() {
      return this.savingAllowAccess;
    },
    requestAccessButtonShow() {
      if (this.hasRequestAccessWithVisit || this.selectIsActive) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      comment: {
        show: false,
        title: null,
        value: null
      },
      contractorCompany: null,
      employees: [],
      employeesIsAuthorized: true,
      employeesPersonalProtectionItemsVerified: true,
      employeesPersonalProtectionItemsVerify: false,
      history: [],
      isLoading: true,
      obligations: [],
      personalProtectionItems: { verify: false },
      requestAccesses: [],
      savingAllowAccess: false,
      showAllowAccess: true,
      vehicles: [],
      vehiclesIsAuthorized: true,
      visit: null,
      type: null
    };
  },
  methods: {
    updateVehicles(vehicle, isAuthorized) {
      this.vehiclesIsAuthorized = isAuthorized;
      if (!this.vehicles.includes(vehicle._id)) {
        this.vehicles.push(vehicle._id);
      } else {
        this.vehicles.splice(this.vehicles.indexOf(vehicle._id), 1);
      }
    },
    updateEmployees(employee, isAuthorized) {
      this.updatePersonalProtectionItem(employee, isAuthorized);
      if (!this.employees.includes(employee._id)) {
        this.employees.push(employee._id);
      } else {
        this.employees.splice(this.employees.indexOf(employee._id), 1);
      }

      this.employeesIsAuthorized =
        isAuthorized && this.employeesPersonalProtectionItemsVerified;
    },
    viewComment(data) {
      this.comment = Object.assign({}, { show: true }, data);
    },
    async allowAccess() {
      this.savingAllowAccess = true;
      const visitParams = {
        vehicles: this.vehicles,
        employees: this.employees
      };
      this.employees.forEach(employee => {
        this.alreadyInEmployees.push(employee);
      });
      this.vehicles.forEach(vehicle => {
        this.alreadyInVehicles.push(vehicle);
      });
      const newVisit = await contractorCompanyService.addVisitWithoutRequestAccess(
        this.contractorCompany._id,
        "active",
        visitParams
      );
      this.visit = newVisit;
      this.savingAllowAccess = false;

      let self = this;

      this.goBackTimeout = setTimeout(function() {
        self.$router.back();
      }, 5000);
    },
    async requestAccess() {
      this.savingAllowAccess = true;
      let employeesPPI = {};
      this.contractorCompany.employees.forEach(e => {
        if (e.currentPersonalProtectionItems.selected == true) {
          employeesPPI[e._id] = e.currentPersonalProtectionItems;
        }
      })
      const newRequestAccess = await contractorCompanyService.createRequestAccess(
        this.contractorCompany._id,
        employeesPPI,
      );
      const visitParams = {
        vehicles: this.vehicles,
        employees: this.employees,
      };
      this.visit = await contractorCompanyService.allowVisitRequestAccess(
        this.contractorCompany._id,
        newRequestAccess._id,
        visitParams,
        "pending_authorization"
      );
      this.requestAccesses.push(newRequestAccess);
      this.savingAllowAccess = false;

      var self = this;
      this.goBackTimeout = setTimeout(function() {
        self.$router.back();
      }, 5000);
    },
    async allowRequestAccess() {
      this.savingAllowAccess = true;
      await contractorCompanyService.updateVisit(
        this.visit._id,
        "active",
        this.visit.hasRequestAccess
      );
      this.visit.state = "active";
      this.savingAllowAccess = false;
      let self = this;

      this.goBackTimeout = setTimeout(function() {
        self.$router.back();
      }, 5000);
    },
    goBack() {
      clearTimeout(this.goBackTimeout);
      this.$router.back();
    },
    updatePersonalProtectionItem(employee, isAuthorized) {
      if (this.employeesPersonalProtectionItemsVerify) {
        employee.currentPersonalProtectionItems.verifies =
          this.personalProtectionItems.helmet ===
            employee.currentPersonalProtectionItems.helmet &&
          this.personalProtectionItems.securityShoes ===
            employee.currentPersonalProtectionItems.securityShoes &&
          this.personalProtectionItems.gloves ===
            employee.currentPersonalProtectionItems.gloves &&
          this.personalProtectionItems.goggles ===
            employee.currentPersonalProtectionItems.goggles &&
          this.personalProtectionItems.auditoryProtector ===
            employee.currentPersonalProtectionItems.auditoryProtector &&
          this.personalProtectionItems.gasMask ===
            employee.currentPersonalProtectionItems.gasMask &&
          this.personalProtectionItems.uniform ===
            employee.currentPersonalProtectionItems.uniform &&
          this.personalProtectionItems.reflectiveVest ===
            employee.currentPersonalProtectionItems.reflectiveVest &&
          this.personalProtectionItems.safetyHarness ===
            employee.currentPersonalProtectionItems.safetyHarness &&
          this.personalProtectionItems.weldingMask ===
            employee.currentPersonalProtectionItems.weldingMask;

        this.employeesPersonalProtectionItemsVerified = this.contractorCompany.employees.every(
          e => {
            if (e._id == employee._id) {
              // verifies means this employee satisfies all required PPI
              e.currentPersonalProtectionItems.verifies =
                employee.currentPersonalProtectionItems.verifies;
              // selected means this employee is selected for this visit
              e.currentPersonalProtectionItems.selected =
                employee.currentPersonalProtectionItems.selected;
            }
            return e.currentPersonalProtectionItems.selected
              ? e.currentPersonalProtectionItems.verifies
              : true;
          }
        );
        this.employeesIsAuthorized =
          isAuthorized && this.employeesPersonalProtectionItemsVerified;
      }
    },
    requestAccessButtonClicked() {
      this.showAllowAccess = false;
      if (this.hasRequestAccessWithVisit) {
        this.allowRequestAccess();
      } else if (this.selectIsAuthorized) {
        this.employeesPersonalProtectionItemsVerified
          ? this.allowAccess()
          : this.requestAccess();
      } else if (!this.selectIsAuthorized) {
        this.requestAccess();
      }
    }
  }
};
</script>

<style lang="scss">
#security-contractor-profile {
  .profile-header {
    .subheading {
      line-height: 20px !important;
    }

    .v-alert {
      padding: 8px;
    }
  }

  .star-rating {
    max-width: 16px;
  }

  .back {
    padding-top: 3px;

    .v-icon {
      font-size: 100px;
    }
  }

  .caption {
    padding-top: 5px;
    padding-left: 15px;
  }

  .d-inline-block {
    padding-top: 5px;
    padding-left: 15px;
  }

  .v-tabs__container {
    border-bottom: 1px solid #ccc;
  }

  .back:hover {
    cursor: pointer;
  }

  #select-visitors-div {
    margin-top: 20px;
  }

  #select-visitors-div .container {
    padding-top: 0px;
  }

  #select-visitors-div .v-icon {
    margin-bottom: 5px;
  }

  .aptitude-container {
    min-height: 50px;
  }

  .v-card .contractor-profile-logo {
    padding-top: 14px;
  }

  .v-card__title {
    word-break: break-word;
    line-height: 1.4rem;
    .ml-2 {
      margin-left: 0px !important;
    }
  }

  .action-column {
    padding: 0 12px;
  }

  .col .v-tabs__div {
    padding-bottom: 14px;
  }

  #vehicles .v-input__control {
    padding-top: 26px;
  }

  .v-card__text {
    .vehicles {
      padding-left: 20px;
      .container {
        .row {
          .v-input--selection-controls__ripple {
            margin: 0px;
          }
        }
      }
      .text-xs-center {
        margin-top: 13px;
      }
      .v-list-item .v-list-item__content {
        max-width: 83% !important;
      }
      .v-input--selection-controls__ripple {
        margin-top: 7px !important;
      }
    }
  }
  .v-input--selection-controls.v-input--checkbox {
    margin-top: -2px !important;
  }
  .employees .text-xs-center .row .col {
    padding: 0px;
    .v-list-item {
      margin-right: 30px;
    }
  }

  .v-list--two-line .v-list-item, .v-list-item--two-line {
    min-height: 74px;
  }

  .employees {
    padding-right: 30px;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    height: 60px;
  }

  .display-1 {
    word-break: break-word;
  }

  .personal-protection-items-images .row {
    padding: 0px;
  }

  .display-1 {
    word-break: break-word;
  }

}

#admin-contractor-profile {
  .v-list-group--sub-group .v-list-group__header .v-tab {
    padding-left: 0px;
  }
  .v-card__text .v-item-group #employees .col {
    padding-right: 0px;
    padding-left: 0px;
    padding-top: 0px;
  }

  .v-list-group__items .v-list-item {
    padding-right: 16px;
    margin-right: 17px;
  }

  .v-list-group__header__prepend-icon {
    align: center;
  }
  .text-xs-center {
    margin-right: 40px;
  }
  .v-tab {
    min-width: 0px;
  }

  .v-card__title .v-alert {
    word-break: break-word;
    line-height: 1.2rem;
  }

  .v-list-item {
    padding-left: 22px;
    .theme--light {
      padding-left: 4px;
      .arrow_drop_down {
        padding-top: 40px;
      }
    }
  }

  .v-list-item__content {
    padding-left: 15px;
  }

  .display-1 {
    word-break: break-word;
  }
}

@media (max-width: 599px) {
  .contractor-profile-logo .v-avatar {
    position: absolute;
    top: 4px;
    right: 8px;
    margin: 6px;
  }
}
</style>
